<template>
  <div class="moduleTitle2">
    <div class="mt_title">{{title}}</div>
    <div class="mt_desc">{{description}}</div>
  </div>
</template>

<script>
export default {
  name: "moduleTitle2",
  props: {
    title: String,
    description:String
  },
  methods: {},
  data() {
    return {};
  },
};
</script>

<style>
.moduleTitle2 {
  width: 100%;
}
.mt_title {
  font-size: 40px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #181818;
}
.mt_desc {
  font-size: 24px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #696969;
  margin: 22px auto 52px auto;
}
</style>


// WEBPACK FOOTER //
// src/components/component/moduleTitle2.vue